export default {
  Url: 'https://sscompany.vip//api/v1/',
  Image: 'https://sscompany.vip/upload',
  base: 'https://sscompany.vip',
};
